import * as Apollo from "@apollo/client";
import { gql } from "@apollo/client";
const defaultOptions = {};
const MoneyFieldsFragmentDoc = gql`
    fragment MoneyFields on Money {
  value
  currency
}
    `;
const ContractValueFieldsFragmentDoc = gql`
    fragment ContractValueFields on ContractValue {
  dollars {
    remaining {
      ...MoneyFields
    }
    original {
      ...MoneyFields
    }
  }
  units {
    remaining
    original
  }
}
    ${MoneyFieldsFragmentDoc}`;
const GetContractBalancesDocument = gql`
    query GetContractBalances($advertiserNation: String!) {
  contractBalances(advertiserNation: $advertiserNation) {
    totalValue {
      dollars {
        remaining {
          value
        }
      }
    }
  }
}
    `;
function useGetContractBalancesQuery(baseOptions) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery(GetContractBalancesDocument, options);
}
function useGetContractBalancesLazyQuery(baseOptions) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery(GetContractBalancesDocument, options);
}
function useGetContractBalancesSuspenseQuery(baseOptions) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery(GetContractBalancesDocument, options);
}
const HirerAccountDocument = gql`
    query HirerAccount {
  hirerAccount {
    billingStatus
    hasAgent
    hidePrice
    nation
  }
}
    `;
function useHirerAccountQuery(baseOptions) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery(HirerAccountDocument, options);
}
function useHirerAccountLazyQuery(baseOptions) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery(HirerAccountDocument, options);
}
function useHirerAccountSuspenseQuery(baseOptions) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery(HirerAccountDocument, options);
}
const GetOrderSummaryDocument = gql`
    query GetOrderSummary($orderId: ID!, $advertiserNation: String!) {
  orderSummary(orderId: $orderId, advertiserNation: $advertiserNation) {
    orderId
    lineItems {
      price {
        netPrice {
          value
        }
      }
      pricing {
        __typename
      }
    }
    total {
      value
      currency
    }
  }
}
    `;
function useGetOrderSummaryQuery(baseOptions) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery(GetOrderSummaryDocument, options);
}
function useGetOrderSummaryLazyQuery(baseOptions) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery(GetOrderSummaryDocument, options);
}
function useGetOrderSummarySuspenseQuery(baseOptions) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery(GetOrderSummaryDocument, options);
}
const ContractBalancesForHirerBalanceDocument = gql`
    query ContractBalancesForHirerBalance($advertiserNation: String!) {
  contractBalances(advertiserNation: $advertiserNation) {
    hideBalance
    title
    contractType
    dollarBased
    adType
    adTypeDescription
    contracts {
      expiry {
        expiryDate
        expiresSoon
        daysRemaining
      }
      createdDate
      validFromDate
      value {
        ...ContractValueFields
      }
      current
    }
    totalValue {
      ...ContractValueFields
    }
    lowBalance
    recommendUpSell
  }
}
    ${ContractValueFieldsFragmentDoc}`;
function useContractBalancesForHirerBalanceQuery(baseOptions) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery(ContractBalancesForHirerBalanceDocument, options);
}
function useContractBalancesForHirerBalanceLazyQuery(baseOptions) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery(ContractBalancesForHirerBalanceDocument, options);
}
function useContractBalancesForHirerBalanceSuspenseQuery(baseOptions) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery(ContractBalancesForHirerBalanceDocument, options);
}
const HirerAccountForHirerBalanceDocument = gql`
    query HirerAccountForHirerBalance {
  hirerAccount {
    pricingModel
    __typename
  }
}
    `;
function useHirerAccountForHirerBalanceQuery(baseOptions) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery(HirerAccountForHirerBalanceDocument, options);
}
function useHirerAccountForHirerBalanceLazyQuery(baseOptions) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery(HirerAccountForHirerBalanceDocument, options);
}
function useHirerAccountForHirerBalanceSuspenseQuery(baseOptions) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery(HirerAccountForHirerBalanceDocument, options);
}
const OrderSummaryDetailsDocument = gql`
    query OrderSummaryDetails($orderId: ID!, $advertiserId: ID, $advertiserNation: String!) {
  orderSummary(
    orderId: $orderId
    advertiserId: $advertiserId
    advertiserNation: $advertiserNation
  ) {
    orderId
    tax {
      rate
      amount {
        value
        currency
      }
      code
      displayRecommendation
    }
    subTotal {
      value
      currency
    }
    total {
      value
      currency
    }
    lineItems {
      product {
        __typename
        productType
        name
        ... on Ad {
          adType
        }
      }
      price {
        retailPrice {
          value
          currency
        }
        netPrice {
          value
          currency
        }
      }
      pricing {
        ... on CappedUnitPrice {
          maxBillableUnits
          unitPrice {
            ... on Price {
              netPrice {
                value
                currency
              }
              tax {
                rate
                code
                displayRecommendation
                amount {
                  value
                  currency
                }
              }
            }
          }
          cappedPrice {
            ... on Price {
              netPrice {
                value
                currency
              }
              tax {
                rate
                code
                displayRecommendation
                amount {
                  value
                  currency
                }
              }
            }
          }
        }
      }
      drawdownItems {
        amount
        drawdownContractDetails {
          contractId
          contractName
          contractType
          adType
          dollarBased
          expiryDate
          currentValue {
            dollars {
              value
              currency
            }
          }
          remainingValue {
            dollars {
              value
              currency
            }
          }
        }
      }
    }
    surcharges {
      surchargeType
      amount {
        value
        currency
      }
    }
  }
}
    `;
function useOrderSummaryDetailsQuery(baseOptions) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery(OrderSummaryDetailsDocument, options);
}
function useOrderSummaryDetailsLazyQuery(baseOptions) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery(OrderSummaryDetailsDocument, options);
}
function useOrderSummaryDetailsSuspenseQuery(baseOptions) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery(OrderSummaryDetailsDocument, options);
}
export {
  ContractBalancesForHirerBalanceDocument,
  ContractValueFieldsFragmentDoc,
  GetContractBalancesDocument,
  GetOrderSummaryDocument,
  HirerAccountDocument,
  HirerAccountForHirerBalanceDocument,
  MoneyFieldsFragmentDoc,
  OrderSummaryDetailsDocument,
  useContractBalancesForHirerBalanceLazyQuery,
  useContractBalancesForHirerBalanceQuery,
  useContractBalancesForHirerBalanceSuspenseQuery,
  useGetContractBalancesLazyQuery,
  useGetContractBalancesQuery,
  useGetContractBalancesSuspenseQuery,
  useGetOrderSummaryLazyQuery,
  useGetOrderSummaryQuery,
  useGetOrderSummarySuspenseQuery,
  useHirerAccountForHirerBalanceLazyQuery,
  useHirerAccountForHirerBalanceQuery,
  useHirerAccountForHirerBalanceSuspenseQuery,
  useHirerAccountLazyQuery,
  useHirerAccountQuery,
  useHirerAccountSuspenseQuery,
  useOrderSummaryDetailsLazyQuery,
  useOrderSummaryDetailsQuery,
  useOrderSummaryDetailsSuspenseQuery
};
